import React from "react";
import { FaAudible } from "react-icons/fa";
import { Twirl as Hamburger } from "hamburger-react";
import Resume from "../components/images/Resume_ COVENANT.pdf";
import { useState } from "react";

const LiItem = ({ title, fn, hText }) => {
  return (
    <li className="mx-5 max-lg:my-5" onClick={fn}>
      <a href={`#${hText}`} className="no-underline text-white font-light">
        {title}
      </a>
    </li>
  );
};

const MobileList = ({ classProps, fn1 }) => {
  const array = ["Main", "About", "Services", "Portfolio", "Contact"];

  return (
    <ul
      className={`glassy flex flex-col fixed z-[60] ${classProps} top-0 bg-[rgba(0,0,0,0.8)]  sm:w-[25rem] w-full h-[100vh] right-0 transition-all duration-500`}
    >
      {["Home", "About", "Services", "Skills", "Contact"].map(
        (textTitle, index) => {
          return (
            <LiItem
              key={index}
              title={textTitle}
              fn={fn1}
              hText={array[index]}
            />
          );
        }
      )}
      <a
        href={Resume}
        download
        className="mx-4 border-blue-700 text-blue-700 border-[0.11rem] py-1 px-3 rounded-lg shadow-xl text-center"
        onClick={fn1}
      >
        Download Cv
      </a>
    </ul>
  );
};

const Header = () => {
  const [isOpen, setOpen] = useState(false);
  let stats;
  const Array = ["Main", "About", "Services", "Portfolio", "Contact"];
  const handleClick = () => {
    if (isOpen == true) {
      setOpen(false);
      stats = "invisible opacity-0";
    }
  };
  return (
    <header className="fixed top-0 w-[100%] z-50">
      <nav className=" lg:block hidden bg-[rgba(0,51,102,0.4)] glassy">
        <div className="max-w-6xl min-h-[4rem] text-white mx-auto flex items-center justify-between font-light">
          <h1 className="text-[2rem] font-[200] flex items-center justify-center">
            PF
            <FaAudible className="text-blue-400" size={30} />R
          </h1>
          <ul className="flex justify-center items-center">
            {["Home", "About", "Services", "Skills", "Contact"].map(
              (textTitle, index) => {
                return (
                  <LiItem key={index} title={textTitle} hText={Array[index]} />
                );
              }
            )}
            <a
              href={Resume}
              download
              className="mx-4 border-blue-700 text-blue-700 border-[0.11rem] py-1 px-3 rounded-lg shadow-xl"
            >
              Download Cv
            </a>
          </ul>
        </div>
      </nav>
      {/* rgba(0,51,102,0.3) */}
      <nav className="max-lg:block hidden fixed top-0 bg-[rgba(0,49,83,0.7)] w-full z-50">
        <div className="max-w-4xl h-[100%] text-white mx-auto flex items-center justify-between px-4">
          <h1 className="text-[2rem] font-[200] flex items-center">
            PF
            <FaAudible className="text-blue-400" size={30} />R
          </h1>
          <div className="z-[90]">
            <Hamburger
              size={25}
              toggled={isOpen}
              toggle={setOpen}
              onToggle={
                !isOpen
                  ? (stats = "invisible opacity-0")
                  : (stats = "visible opacity-100")
              }
              duration={0.2}
            />
          </div>
          <MobileList classProps={stats} fn1={handleClick} />
        </div>
      </nav>
    </header>
  );
};

export default Header;
